import { render, staticRenderFns } from "./BeneficiaryModal.vue?vue&type=template&id=7d6bf88b"
import script from "./BeneficiaryModal.vue?vue&type=script&lang=js"
export * from "./BeneficiaryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports